import type { RouteObject } from "react-router";

import { ErrorPage } from "@/components/Error/ErrorPage";
import { canAccessProjectRolesAndPermissions } from "@/components/ProjectSidebar/permissions";
import { RequireAuth } from "@/components/Routing/RequireAuth";

import { canManageRoles } from "./permissions";
import { roleRoutes } from "./routes";

export const rolesRoute = [
  {
    path: roleRoutes.list,
    lazy: async () => {
      const { RoleListPage } = await import("./pages/RoleListPage");

      return {
        element: (
          <RequireAuth permission={canAccessProjectRolesAndPermissions}>
            <RoleListPage />
          </RequireAuth>
        ),
      };
    },
  },
  {
    path: roleRoutes.create,
    lazy: async () => {
      const { CreateRolePage } = await import("./pages/CreateRolePage");

      return {
        element: (
          <RequireAuth permission={canManageRoles}>
            <CreateRolePage />
          </RequireAuth>
        ),
      };
    },
  },

  {
    path: roleRoutes.edit,
    lazy: async () => {
      const { EditRolePage } = await import("./pages/EditRolePage");

      return {
        element: (
          <RequireAuth permission={canManageRoles}>
            <EditRolePage />
          </RequireAuth>
        ),
      };
    },
  },
  {
    path: roleRoutes.details,
    lazy: async () => {
      const { RoleDetailsPage } = await import("./pages/RoleDetailsPage");

      return {
        element: (
          <RequireAuth permission={canManageRoles}>
            <RoleDetailsPage />
          </RequireAuth>
        ),
      };
    },
  },
  { path: "*", element: <ErrorPage status={404} /> },
] satisfies RouteObject[];
